import ApiServer from "../ApiServer.ts";
import {
  resolvePremiumEligibility,
  type PremiumEligibility
} from "./premium-eligibility.ts";

export async function checkPremiumEligibility(): Promise<PremiumEligibility> {
  return resolvePremiumEligibility(await ApiServer.creditlistall());
}
